
export default function getDocumentType(contentType: string) {
  switch (contentType) {
    case 'image/png':
    case 'image/jpg':
    case 'image/jpeg':
    case 'image/gif':
    case 'image/webp':
      return 'image';
    case 'application/pdf':
      return 'pdf';
    default:
      return 'unknown';
  }
}
